export enum ResolutionStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  UNRESOLVED = 'unresolved',
  AUTO_APPLIED = 'auto-applied',
}

export type SuggestionAction = 'accept' | 'reject';
